const formatDistanceKm = (value) => {
    if (value === null || value === undefined) return '';

    if (typeof value === 'number') {
        return Number.isFinite(value) ? `${value}km` : '';
    }

    const raw = String(value).trim();
    if (!raw) return '';

    const cleaned = raw.replace(/,/g, '');
    const kmMatch = cleaned.match(/(\d+(?:\.\d+)?)\s*(km|\uD0AC\uB85C\uBBF8\uD130)/i);
    if (kmMatch) {
        const kmValue = parseFloat(kmMatch[1]);
        return Number.isFinite(kmValue) ? `${kmValue}km` : '';
    }

    const mMatch = cleaned.match(/(\d+(?:\.\d+)?)\s*(m|\uBBF8\uD130)/i);
    if (mMatch) {
        const meters = parseFloat(mMatch[1]);
        if (!Number.isFinite(meters)) return '';
        const kmValue = parseFloat((meters / 1000).toFixed(2));
        return `${kmValue}km`;
    }

    if (/^\d+(?:\.\d+)?$/.test(cleaned)) {
        const kmValue = parseFloat(cleaned);
        return Number.isFinite(kmValue) ? `${kmValue}km` : '';
    }

    return '';
};

const normalizeCoordinate = (value) => {
    const num = Number(value);
    return Number.isFinite(num) ? num : null;
};

const getPlaceLatLng = (place) => {
    if (!place) return null;
    const lat = normalizeCoordinate(place?.latitude ?? place?.lat ?? place?.y);
    const lng = normalizeCoordinate(place?.longitude ?? place?.lng ?? place?.x);
    if (lat === null || lng === null) return null;
    return { lat, lng };
};

const haversineKm = (from, to) => {
    if (!from || !to) return null;
    const toRad = (value) => (value * Math.PI) / 180;
    const dLat = toRad(to.lat - from.lat);
    const dLng = toRad(to.lng - from.lng);
    const lat1 = toRad(from.lat);
    const lat2 = toRad(to.lat);

    const sinLat = Math.sin(dLat / 2);
    const sinLng = Math.sin(dLng / 2);
    const a = sinLat * sinLat + Math.cos(lat1) * Math.cos(lat2) * sinLng * sinLng;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return 6371 * c;
};

export const getDistanceLabel = (place, nextPlace) => {
    const directLabel = formatDistanceKm(place?.dist ?? place?.distance ?? place?.distanceToNext);
    if (directLabel) return directLabel;

    const from = getPlaceLatLng(place);
    const to = getPlaceLatLng(nextPlace);
    if (!from || !to) return '';

    const km = haversineKm(from, to);
    if (!Number.isFinite(km)) return '';
    const rounded = Math.round(km * 10) / 10;
    return formatDistanceKm(rounded);
};

export default formatDistanceKm;
